import { createSlice } from '@reduxjs/toolkit';
import { RootState } from '../store/Store';
import { authApi } from './Auth.api';
import { tokenService } from '../../service/Token.service';
import { removeEntry } from '../../service/LocalStorage.service';
import { ISignInResponseDto } from './Auth.model';
import jwtDecode from 'jwt-decode'

const REPORT_TIME_RANGE_LS_KEY = 'report_timeRangeSelection'
const REPORT_FILTERS_LS_KEY = 'report_filtersSelection'
const TICKET_TIME_RANGE_LS_KEY = 'ticket_timeRangeSelection'
const TICKET_FILTERS_LS_KEY = 'ticket_filtersSelection'
const ASSET_FILTERS_LS_KEY = 'asset_filtersSelection'
const CLIENT_FILTERS_LS_KEY = 'client_filtersSelection'
const CONTACT_FILTERS_LS_KEY = 'contact_filtersSelection'
const CONTRACT_FILTERS_LS_KEY = 'contract_filtersSelection'
const USER_FILTERS_LS_KEY = 'user_filtersSelection'

type InitialState = {
  store: ISignInResponseDto | undefined
}

const initialState = {
  store: tokenService.getTokens(),
} as InitialState

export const authSlice = createSlice({
  name: 'auth',
  initialState,
  reducers: {
    loadSession(state) {
      const response = tokenService.getTokens()
      if (response?.tokens?.idToken) {
        state.store = response
      } else {
        state = initialState
      }
    },
    signOut(state) {
      tokenService.clearTokens()
      removeEntry(REPORT_TIME_RANGE_LS_KEY)
      removeEntry(REPORT_FILTERS_LS_KEY)
      removeEntry(TICKET_TIME_RANGE_LS_KEY)
      removeEntry(TICKET_FILTERS_LS_KEY)
      removeEntry(ASSET_FILTERS_LS_KEY)
      removeEntry(CLIENT_FILTERS_LS_KEY)
      removeEntry(CONTACT_FILTERS_LS_KEY)
      removeEntry(CONTRACT_FILTERS_LS_KEY)
      removeEntry(USER_FILTERS_LS_KEY)
      state = initialState
    },
  },
  extraReducers(builder) {
    builder
      .addMatcher(authApi.endpoints.signIn.matchFulfilled, (state, action) => {
        if (action.payload.tokens?.idToken || action.payload.session) {
          if (action.payload.tokens?.idToken) {
            tokenService.setTokens(action.payload)
          }
          state.store = action.payload
        } else {
          tokenService.clearTokens()
          state = initialState
        }
      })
      .addMatcher(authApi.endpoints.signIn.matchRejected, (state, action) => {
        tokenService.clearTokens()
        state = initialState
      })
      .addMatcher(authApi.endpoints.refreshSession.matchFulfilled, (state, action) => {
        if (action.payload.tokens?.idToken) {
          tokenService.setTokens(action.payload)
          state.store = action.payload
        } else {
          tokenService.clearTokens()
          state = initialState
        }
      })
      .addMatcher(authApi.endpoints.refreshSession.matchRejected, (state, action) => {
        tokenService.clearTokens()
        state = initialState
      })
  },
})

export const {loadSession, signOut} = authSlice.actions
export default authSlice.reducer

export const selectAuth = (state: RootState) => state.authReducer.store
export const selectIsAuthenticated = (state: RootState) => {
  if (state.authReducer.store?.tokens?.idToken) {
    const decodedToken: any = jwtDecode(state.authReducer.store.tokens.idToken)
    const currentTime = Date.now() / 1000
    const expireTime = decodedToken.exp
    return expireTime > currentTime
  }
  return false;
}
export const selectIsChallenged = (state: RootState) =>
  !state.authReducer.store?.tokens?.idToken && state.authReducer.store?.session
